'use strict';

const MONTHS = ['January', 'February', 'March', 'April', 'May', 'June',
  'July', 'August', 'September', 'October', 'November', 'December'
];

function stringToDate(dateString) {
  var year = parseInt(dateString.substr(0, 4), 10);
  var month = parseInt(dateString.substr(4, 2), 10) - 1;
  var day = parseInt(dateString.substr(6, 2), 10);

  return new Date(year, month, day);
}

export default () => {
  return (d) => {
    if (typeof d.getMonth !== 'function') {
      d = stringToDate(d);
    }

    return `${d.getDate()} ${MONTHS[d.getMonth()].substr(0, 3)}, ${d.getFullYear()}`;
  };
};



// WEBPACK FOOTER //
// ./app/src/filters/long_short_date.filter.js